import api, { apiErr } from "@/lib/api";
import { loadRazorpayScript } from "@/lib/razorpay";

// Single client entry into the central plan-change workflow. The browser never decides the
// outcome: activation is reported by the backend only after it verifies payment with Razorpay.
export async function startPlanCheckout({ planCode, interval, onResult, theme = "#0f172a" }) {
  const ok = await loadRazorpayScript();
  if (!ok) return onResult({ state: "error", message: "Couldn't load the payment gateway. Please try again." });
  let order;
  try { order = (await api.post("/saas/plan-change/start", { plan_code: planCode, billing_interval: interval })).data; }
  catch (e) { return onResult({ state: "error", message: apiErr(e) }); }
  let settled = false;
  const mark = (reason) => { if (!settled) { settled = true; api.post(`/saas/plan-change/${order.attempt_id}/cancel`, { reason }).catch(() => {}); } };
  const rzp = new window.Razorpay({
    key: order.key_id, order_id: order.order_id, amount: order.amount_paise, currency: order.currency,
    name: "Pawkt", description: `${order.plan_name} plan (${order.billing_interval})`,
    handler: async (resp) => {
      settled = true;
      onResult({ state: "verifying" });
      try {
        const r = (await api.post("/saas/plan-change/verify", {
          razorpay_order_id: resp.razorpay_order_id, razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature })).data;
        onResult({ state: r.activated ? "activated" : "paid_pending", data: r, order });
      } catch (e) { onResult({ state: "unverified", message: apiErr(e), order }); }
    },
    modal: { ondismiss: () => { mark("cancelled"); onResult({ state: "cancelled", order }); } },
    theme: { color: theme },
  });
  rzp.on("payment.failed", () => { mark("failed"); onResult({ state: "failed", order }); });
  rzp.open();
  onResult({ state: "open", order });
}
